<template>
  <div class="mb-24" v-if="paidSelectServices.length">
    <SpaceTitle>{{ __("title_selected_additional_package") }}</SpaceTitle>

    <div class="flex flex-wrap -m-7">
      <ListItem
        v-for="service in paidSelectServices"
        :key="service.id"
        :id="service.id"
        :name="service.name"
        :description="service.description"
        :currency="service.currency"
        :items="service.items"
        :selected="service.selected"
        :image="service.image_path"
        :disabled="true"
        :locked="true"
      />
    </div>
  </div>

  <SpaceTitle>{{ __("title_select_additional_package") }}</SpaceTitle>

  <div v-if="selectServices.length" class="flex flex-wrap -m-7">
    <ListItem
      v-for="service in selectServices"
      :key="service.id"
      :id="service.id"
      :name="service.name"
      :description="service.description"
      :currency="service.currency"
      :items="service.items"
      :selected="service.selected"
      :image="service.image_path"
      :disabled="loading"
    />
  </div>

  <Alert v-else>
    {{ __("additional_services_not_available") }}
  </Alert>

  <div class="mt-16">
    <Price />

    <div class="flex justify-end flex-wrap -mx-6 -mb-6 mt-10">
      <div class="w-full p-6 md:w-1/2 lg:w-128">
        <Button
          variant="third"
          size="full"
          :disabled="loading"
          @click="prevStep"
        >
          {{ __("btn_back") }}
        </Button>
      </div>

      <div class="w-full p-6 md:w-1/2 lg:w-128">
        <Button
          variant="secondary"
          size="full"
          :loading="loading"
          @click="nextStep"
        >
          {{ __("btn_next") }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { checkOrder } from "@/stores/Order";
import {
  selectServices,
  paidSelectServices,
  addServices
} from "@/stores/Services";
import { setAmountServiceView, setOverviewView } from "@/stores/View";

import ListItem from "@/components/SelectService/ListItem";
import Button from "@/components/Button";
import SpaceTitle from "@/components/SpaceTitle";
import Price from "@/components/Price";
import Alert from "@/components/Alert.vue";

export default {
  components: {
    Alert,
    ListItem,
    Button,
    SpaceTitle,
    Price
  },
  setup() {
    const loading = ref(false);
    const nextStep = async () => {
      loading.value = true;
      await addServices();
      await checkOrder();
      setOverviewView();
      loading.value = false;
    };

    const prevStep = () => {
      setAmountServiceView();
    };

    const filteredServices = computed(() => {
      return [...selectServices.value].filter(service => service.can_select);
    });

    return {
      loading,
      selectServices: filteredServices,
      paidSelectServices,
      nextStep,
      prevStep
    };
  }
};
</script>
